













































































import Vue from 'vue';
import Component from 'vue-class-component';
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bpc-shopping-cart-empty',
  components: {},
})
export default class ShoppingCartEmpty extends Vue {
  get bookingsModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.BOOKINGS_MODULE_NAME);
  }
  get activitiesModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.ACTIVITIES_MODULE_NAME);
  }
}
